import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { Label, LabelVariant } from '@ets/design-system';

type TaskStatusProps = { taskState: Card.Task.State; taskStatus: Card.Task.Status };

const STATUS: {
  [key in Card.Task.Status]: { label: string; color: LabelVariant };
} = {
  td: { label: 'TODO', color: 'grey' },
  pr: { label: 'IN_PROGRESS', color: 'blue' },
  d: { label: 'auth.login.done', color: 'green' },
};

const TaskStatus = ({ taskState, taskStatus }: TaskStatusProps) => {
  const status = useMemo<
    | {
        label: string;
        color: LabelVariant;
      }
    | undefined
  >(() => {
    if (taskState === 'Cancelled') {
      return { label: 'editor.sidebar.review.filter.status.deleted', color: 'red' };
    } else if (taskStatus) {
      return STATUS[taskStatus as keyof typeof STATUS];
    } else {
      return undefined;
    }
  }, [taskState, taskStatus]);

  if (status) {
    return (
      <Label size="s" variant={status.color} testId="task-status">
        <FormattedMessage id={status.label} />
      </Label>
    );
  }

  return null;
};

export default TaskStatus;
